import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=75bc53c8&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=ts&"
export * from "./ItemList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=75bc53c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc53c8",
  null
  
)

export default component.exports